import IconDots from "@common/components/icons/IconDots/IconDots";
import { persistUTMQueryParamsToString } from "@common/utils/router";
import { ActionIcon, Menu } from "@mantine/core";
import { IPurchase } from "@stores/purchases/types";
import { isCanceledOrDeleted } from "@stores/purchases/utils";
import { SUBSCRIPTION_STATUS_CANCELLATION_PENDING } from "@stores/subscriptions/constants";
import Link from "next/link";
import { useRouter } from "next/router";

export function SelfHostedMoreMenu({ purchase }: { purchase: IPurchase }) {
  const router = useRouter();
  const isCancellationPending =
    purchase.subscription.status === SUBSCRIPTION_STATUS_CANCELLATION_PENDING;
  const isPurchaseCanceledOrDeleted = isCanceledOrDeleted(purchase);

  if (isCancellationPending || isPurchaseCanceledOrDeleted) {
    return null;
  }

  return (
    <Menu withinPortal position="bottom-end" offset={4}>
      <Menu.Target>
        <ActionIcon aria-label="Common actions">
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          href={persistUTMQueryParamsToString(
            router,
            `/account/${purchase.id}/cancel`,
          )}
        >
          Cancel subscription
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
